import React from "react";
import { FormLabel } from "react-bootstrap";

const CustomLabel = ({ htmlFor = "", label = "", isRequired = false }) => {
  return (
    <FormLabel htmlFor={htmlFor}>
      {label}
      {isRequired && <span className="text-danger">*</span>}
    </FormLabel>
  );
};

export default CustomLabel;
